import { render, staticRenderFns } from "./ShoppingMall.vue?vue&type=template&id=583d3aaf&scoped=true"
import script from "./ShoppingMall.vue?vue&type=script&lang=js"
export * from "./ShoppingMall.vue?vue&type=script&lang=js"
import style0 from "./ShoppingMall.vue?vue&type=style&index=0&id=583d3aaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583d3aaf",
  null
  
)

export default component.exports